import Module from '@/store/resource/common/module';
import Links from '@/store/resource/links';

let module = new Module(new Links());

export default module.create();
